<template>
  <div class="wrapper d-flex">
    <div class="not-found-page">
      <h2>
        4
        <span>0</span>4
      </h2>
      <p>Page not found.</p>
      <v-btn
        depressed
        rounded
        x-large
        color="primary"
        @click="clearError"
        :to="{ name: 'frontend' }"
      >Return to Homepage</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageNotFoundView',
  methods: {
    clearError() {
      this.$store.dispatch('errors/clearError')
    }
  }
}
</script>

<style lang="scss">
html,
body,
#app {
  min-height: 456px;
  font-family: sans-serif;
  margin: 0;
  padding: 0;
}

.wrapper {
  height: 100vh;
  width: 100%;
  text-align: center;
  align-items: center;
}

.not-found-page {
  margin: 0 auto !important;
  -ms-flex-item-align: center;
  align-self: center;

  h2 {
    color: #5f5656;
    font-size: 128px;
    margin: 0;

    span {
      color: #f31717;
    }
  }

  p {
    color: #b8b7b9;
    margin: 0;
    margin-bottom: 32px;
  }

  a {
    background: #1371d2;
    color: white;
    text-decoration: none;
    padding: 16px 21px;
    border-radius: 24px;
  }
}
</style>
